const PERMISSIONS = {
  ROLES_UPDATED: 'ROLES_UPDATED'
}

export default PERMISSIONS
